@import '~style-sheet-helpers/core.less';

.delete-package-set-modal {
  width: 400px;
}

.modal-body {
  padding: 15px;
  max-height: 300px;
}

.modal-text {
  display: inline;
  font-size: 13px;
}

.modal-footer {
  > button {
    margin-left: 10px;
  }
}
